/**
 * Campaign + landing-variant context for funnel analytics.
 *
 * Only pseudonymous acquisition metadata is stored here. Name, email, birth
 * details and generated report text must never be passed through this module.
 */

const STORAGE_KEY = "ayupath-campaign";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

function deviceCategory() {
  if (typeof window === "undefined") return "unknown";
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

function referrerCategory() {
  if (typeof document === "undefined" || !document.referrer) return "direct";
  try {
    const host = new URL(document.referrer).hostname.replace(/^www\./, "");
    if (host === window.location.hostname) return "internal";
    if (/(google|bing|duckduckgo|yahoo|ecosia)\./.test(host)) return "search";
    if (/(facebook|instagram|tiktok|youtube|pinterest|reddit|linkedin|t\.co)/.test(host)) return "social";
    return "referral";
  } catch {
    return "unknown";
  }
}

function readUtmParams() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  return UTM_KEYS.reduce((acc, key) => {
    const value = params.get(key);
    if (value) acc[key] = value.slice(0, 100);
    return acc;
  }, {});
}

/**
 * Records which landing variant the visitor entered through so later funnel
 * events (teaser, checkout, purchase) can be attributed back to it.
 */
export function captureCampaign({ pageVariant, campaignId } = {}) {
  const context = {
    page_variant: pageVariant || "vedic-timeline-v1",
    campaign_id: campaignId || "none",
    referrer_category: referrerCategory(),
    device_category: deviceCategory(),
    ...readUtmParams(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  } catch {
    // Private browsing or storage disabled — attribution degrades, funnel still works.
  }

  return context;
}

export function getCampaignContext() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}
